// extracted by mini-css-extract-plugin
export default {"toggleContainer":"ToggleInput_toggleContainer__ZIS98","toggle-wrapper":"ToggleInput_toggle-wrapper__bOyDH","base":"ToggleInput_base__E3uiL","large":"ToggleInput_large__32reD"};